import { FormSchema } from '@/components/Form';
import { useI18n } from '@/hooks/web/useI18n';
const { t }=useI18n()
export const formSchema: FormSchema[] = [
  {
    field: 'passwordOld',
    label: t('component.password.当前密码'),
    componentProps: {
      placeholder: t('component.password.当前密码'),
    },
    component: 'InputPassword',
    required: true,
  },
  {
    field: 'passwordNew',
    label: t('component.password.新密码'),
    component: 'StrengthMeter',
    componentProps: {
      placeholder: t('component.password.新密码'),
    },
    dynamicRules: ({ values }) => {
      return [
        {
          required: true,
          validator: (_, value) => {
            if((window as any).somePweFlag){
              if (value === values.passwordOld) {
                return Promise.reject(t('新密码不能与上次密码一样!'));
              }
            }
            return Promise.resolve();
          },
        },
      ];
    },
    required: true,
  },
  {
    field: 'confirmPassword',
    label: t('component.password.确认密码'),
    component: 'InputPassword',
    componentProps: {
      placeholder: t('component.password.确认密码'),
    },
    dynamicRules: ({ values }) => {
      return [
        {
          required: true,
          validator: (_, value) => {
            if (!value) {
              return Promise.reject(t('component.password.密码不能为空'));
            }
            if (value !== values.passwordNew) {
              return Promise.reject(t('component.password.两次输入的密码不一致!'));
            }
            return Promise.resolve();
          },
        },
      ];
    },
  },
];
